// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, signOut } from "firebase/auth";
import { getFirestore} from "firebase/firestore";
import { ENV_CONFIG } from '../config/environment';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: ENV_CONFIG.FIREBASE.API_KEY,
  authDomain: ENV_CONFIG.FIREBASE.AUTH_DOMAIN,
  databaseURL: ENV_CONFIG.FIREBASE.DATABASE_URL,
  projectId: ENV_CONFIG.FIREBASE.PROJECT_ID,
  storageBucket: ENV_CONFIG.FIREBASE.STORAGE_BUCKET,
  messagingSenderId: ENV_CONFIG.FIREBASE.MESSAGING_SENDER_ID,
  appId: ENV_CONFIG.FIREBASE.APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const handleLogout = () => {
  signOut(auth);
};

export {auth,db,handleLogout};